import dayGridPlugin from '@fullcalendar/daygrid';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CalendarOptions, DatesSetArg } from '@fullcalendar/core';
import { MailBoxService } from 'src/app/core/services/mail-box/mail-box.service';
import { DatePipe } from '@angular/common';
import { TruncatePipe } from 'src/app/core/pipe/truncate.pipe';
import { MatMenuTrigger } from '@angular/material/menu';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-event-calender',
  templateUrl: './event-calender.component.html',
  styleUrls: ['./event-calender.component.scss'],
})
export class EventCalenderComponent implements OnInit {
  @ViewChild(MatMenuTrigger, { static: false }) menuTrigger: MatMenuTrigger | undefined;
  @ViewChild('menuTrigger', { static: false, read: ElementRef }) menuTriggerButton: ElementRef | undefined;
  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    weekends: true,
    events: [],
    plugins: [dayGridPlugin],
    datesSet: this.onDatesSet.bind(this),
    eventClick: this.onEventClick.bind(this)
  };
  selectedEvent: any = null;
  isCanceled: boolean = false;
  userDetails: any = null;
  userEmails: string = '';

  constructor(
    private _mailService: MailBoxService,
    private datePipe: DatePipe,
    private truncate: TruncatePipe,
    private _localstorageService: LocalStorageService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.userDetails = this._localstorageService.getUser();
    if (this.userDetails) {
      this.userEmails = this.userDetails?.inboxMail.map((item) => item?.mail).join(',');
    }
    this.titleService.setTitle('Event Calendar');
  }


  onDatesSet(arg: DatesSetArg) {
    const { start, end } = arg;
    const startUnixTimestamp = Math.floor(start.getTime() / 1000).toString();
    const endUnixTimestamp = Math.floor(end.getTime() / 1000).toString();
    setTimeout(() => {
      this.loadEventsForRange(this.userEmails, startUnixTimestamp, endUnixTimestamp);
    }, 400)
  }

  loadEventsForRange(email: string, start: string, end: string) {
    this._mailService.getCalederData(email, start, end).subscribe({
      next: (res: any) => {
        if (res?.statusCode === 200 && res?.success && res?.data?.data?.length > 0) {
          this.calendarOptions = {
            events: res?.data?.data.map((item) => {
              const { title, meetingId, startDate, startDateGMT, timeZone } = item
              const updatedTtitle = `${this.datePipe.transform(this._mailService.convertToIST(startDateGMT, timeZone), 'HH:mm a')} ${this.truncate.transform(title, 10)?.text}`
              return {
                title: updatedTtitle,
                date: this.datePipe.transform(startDate, 'YYYY-MM-dd'),
                id: meetingId,
                extendedProps: item
              }
            })
          }
        } else {
          this.calendarOptions = {
            ...this.calendarOptions,
            events: []
          }
        }
      }
    })
  }

  convertLinksToAnchorTags(text) {
    // Regular expression to match URLs
    const urlRegex = /(?:https?|ftp):\/\/[^\s/$.?#].[^\s]*/g;

    // Replace URLs with anchor tags
    return text.replace(urlRegex, function (url) {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });
  }

  onEventClick(eventInfo: any) {
    const eventTarget = eventInfo.jsEvent.target as HTMLElement;
    const boundingRect = eventTarget.getBoundingClientRect();

    const updatedMailData = [eventInfo.event.extendedProps].map((item) => {
      const { startDateGMT, endDateGMT, timeZone, status, description, ...rest } = item;
      const startDateTime = this._mailService.convertToIST(startDateGMT, timeZone);
      const endDateTime = this._mailService.convertToIST(endDateGMT, timeZone);
      this.isCanceled = status === 'CANCELLED';
      return {
        ...rest,
        startDateTime,
        endDateTime,
        description: this.convertLinksToAnchorTags(description)
      };
    })[0];
    this.selectedEvent = updatedMailData;

    // Dynamically position the hidden button
    const triggerButton = this.menuTriggerButton?.nativeElement as HTMLElement;
    triggerButton.style.top = `${boundingRect.top + window.scrollY}px`;
    triggerButton.style.left = `${boundingRect.left}px`;
    triggerButton.style.visibility = 'visible'; // Ensure it's temporarily visible to trigger the menu

    // Open the menu
    this.menuTrigger?.openMenu();
  }
}
